import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { IProgramType } from 'legacy/lut/features/partner360/configuration'

import { getAvailableProgramTypes } from 'partner360/helpers/offerings/getAvailableProgramTypes'
import { getOfferingsInfo } from 'partner360/helpers/offerings/getOfferingsInfo'

/** The partner's programmes in their tab order, without `Overall`, which is not one to switch. */
export const getSwitchableCockpitOfferings = (programTypes: IProgramType[]) =>
  getOfferingsInfo(getAvailableProgramTypes(programTypes))
    .currentOfferings.filter(({ programType }) => programType !== ProgramTypes.Overall)
    .sort((a, b) => a.orderBy - b.orderBy)
